<template>
  <a-spin :spinning="loading">
    <a-row class="not-resize-for-mobile">
      <!-- 文件夹树 -->
      <a-col :sm="24" :lg="6" style="border-right: 1px solid #e8e8e8">
        <a-card :bordered="false">
          <a-alert type="info" :showIcon="true">
            <div slot="message" style="display: flex">
              <span v-if="this.currSelected.title">{{ $t('disp.selected') + '：' }}</span>
              <span v-else>{{ $t('请选择一个文件夹') }}</span>
              <span
                v-if="this.currSelected.title"
                style="
                  max-width: calc(100% - 106px);
                  display: inline-block;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                "
                >{{ getCurrSelectedTitle() }}</span
              >
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelectedTree">{{
                $t('disp.btn.cancel')
              }}</a>
            </div>
          </a-alert>

          <a-input-search
            @search="onSearch"
            style="width: 100%; margin-top: 10px"
            v-model="searchText"
            placeholder="检索文件夹"
          />

          <div class="div-file-manage-tree-wrapper">
            <a-empty v-show="treeData.length == 0" style="padding: 55px"></a-empty>
            <a-tree
              v-show="treeData.length > 0"
              class="file-manage-tree"
              :treeData="treeData"
              default-expand-all
              :autoExpandParent="autoExpandParent"
              :showLine="false"
              :defaultExpandAll="true"
              :selectedKeys="selectedKeys"
              :expandedKeys="iExpandedKeys"
              @select="onSelect"
              @expand="onExpand"
              :style="computeStyle"
              style="overflow-y: auto; overflow-x: hidden; margin-top: 10px"
            >
              <div slot="hasSlot" slot-scope="{ key, title, isRoot }">
                <a-icon v-if="key == selectedKeys" theme="filled" type="folder-open" class="i-folder"></a-icon>
                <a-icon v-else theme="filled" type="folder" class="i-folder"></a-icon>
                <div
                  style="
                    display: inline-block;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    line-height: 18px;
                    position: relative;
                    top: 4px;
                  "
                  class="div-text"
                  v-html="keywordsColorful(title, searchText)"
                ></div>

                <div class="i-op-wrapper" :class="key == selectedKeys ? 'show' : ''">
                  <i
                    title="重命名"
                    class="mdi mdi-pencil-circle"
                    style="color: var(--color-orange)"
                    @click.stop="folderRename"
                  ></i>

                  <i
                    title="添加文件夹"
                    class="mdi mdi-plus-circle"
                    style="color: var(--color-green)"
                    @click.stop="folderAdd"
                  ></i>

                  <i
                    title="删除"
                    class="mdi mdi-minus-circle"
                    style="color: var(--color-red)"
                    @click.stop="folderDelete"
                  ></i>

                  <i
                    title="移动文件夹"
                    class="mdi mdi-share-circle"
                    style="color: var(--color-blue)"
                    @click.stop="folderMove"
                  ></i>

                  <!--<a-icon title="重命名" type="form" style="color: darkorange" @click.stop="folderRename"></a-icon>-->
                  <!--<a-icon title="添加文件夹" theme="twoTone" type="plus-circle" @click.stop="folderAdd"></a-icon>-->
                  <!--<a-icon
                      v-if="!isRoot"
                      title="删除"
                      theme="twoTone"
                      type="minus-circle"
                      twoToneColor="#f5222d"
                      @click.stop="folderDelete"
                    ></a-icon>-->
                  <!--<a-icon
                      v-if="!isRoot"
                      title="移动文件夹"
                      type="right-circle"
                      theme="twoTone"
                      twoToneColor="#bbb"
                      @click.stop="folderMove"
                    ></a-icon>-->
                </div>
              </div>
            </a-tree>
          </div>
        </a-card>
      </a-col>

      <!-- 文件信息 -->
      <a-col :sm="24" :lg="18" style="padding: 0 23px 24px 24px">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="文件信息" key="1">
            <a-empty v-if="!currSelected.key" :description="$t('请在左侧选择一个文件夹')" style="margin: 10% 0" />

            <div v-else>
              <!-- 検索区域 -->
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="queryTreeNodeInfo">
                  <a-row :gutter="24">
                    <a-col :sm="16" :md="10" :lg="12" :xl="8" :xxl="6">
                      <a-form-item>
                        <a-input
                          placeholder="文件名模糊查询"
                          v-model="searchName"
                          @change="queryTreeNodeInfo"
                        ></a-input>
                      </a-form-item>
                    </a-col>

                    <a-col :xs="1" :sm="1" class="width-fit-content">
                      <a-form-item :wrapperCol="{ span: 24 }">
                        <a-button type="primary" @click="queryTreeNodeInfo" icon="search">{{
                          $t('disp.btn.search')
                        }}</a-button>
                        <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </div>

              <!-- ボタン操作区域 -->
              <div class="table-operator">
                <a-button type="primary" icon="plus" @click="uploadFileSet">添加文件</a-button>
                <input type="file" id="upFile" multiple hidden @change="upfileSelected" />

                <a-button
                  type="primary"
                  ghost
                  :disabled="selectedRowKeys.length == 0"
                  @click="batchDownload"
                  icon="download"
                  >批量下载</a-button
                >

                <a-button
                  type="primary"
                  ghost
                  :disabled="selectedRowKeys.length == 0"
                  @click="batchMove"
                  icon="arrow-right"
                  >批量移动</a-button
                >

                <a-button type="danger" ghost :disabled="selectedRowKeys.length == 0" @click="batchDel" icon="close">{{
                  this.$t('disp.btn.deleteBatch')
                }}</a-button>
              </div>

              <div class="calc-depart-content">
                <div class="ant-alert ant-alert-info div-selected-info">
                  <i class="anticon anticon-info-circle ant-alert-icon"></i>
                  {{ this.$t('disp.selected') }}
                  <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
                  {{ this.$t('disp.item') }}
                  <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
                </div>

                <a-table
                  ref="table"
                  class="file-manage-table action"
                  tableLayout="auto"
                  :bordered="false"
                  :columns="columns"
                  :dataSource="dataSource"
                  :pagination="ipagination"
                  :loading="loading"
                  :rowSelection="{
                    selectedRowKeys: selectedRowKeys,
                    onChange: onSelectChange,
                  }"
                  @change="handleTableChange"
                >
                  <div slot="icon" slot-scope="text, record">
                    <div class="div-fileType">
                      <img :src="getIcon(record)" />
                    </div>
                  </div>

                  <div slot="fileName" slot-scope="text, record">
                    <a-input
                      style="width: calc(100% - 50px)"
                      v-if="record.editable"
                      :value="text"
                      allowClear
                      @change="(e) => handleChange(e.target.value, record.id, 'fileName')"
                      @keyup.enter.stop="save(record)"
                    />
                    <div v-else style="white-space: normal; word-break: break-all; line-height: 18px">
                      <span class="span-main">{{ record.fileName.split('.' + record.fileType)[0] }}</span>
                      <span class="span-sub">{{ '.' + record.fileType }}</span>
                    </div>
                  </div>

                  <div slot="fileModifiedTime" slot-scope="text, record">
                    <span class="span-main">{{ record.fileModifiedTime | dateformat('YYYY-MM-DD') }}</span>
                    <span class="span-sub">{{ record.fileModifiedTime | dateformat(' HH:mm:ss') }}</span>
                  </div>

                  <div slot="fileCreatedTime" slot-scope="text, record">
                    <span class="span-main">{{ record.fileCreatedTime | dateformat('YYYY-MM-DD') }}</span>
                    <span class="span-sub">{{ record.fileCreatedTime | dateformat(' HH:mm:ss') }}</span>
                  </div>

                  <div slot="fileSize" slot-scope="text, record">
                    <span v-html="getFileSize(record)"></span>
                  </div>

                  <div slot="action" slot-scope="text, record" style="white-space: nowrap">
                    <!-- <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a> -->
                    <span v-if="record.editable">
                      <a @click="save(record)">保存</a>
                      <a-divider type="vertical" />
                      <a @click="cancel(record.id)">取消</a>
                    </span>

                    <span v-else>
                      <a :disabled="editingKey !== ''" @click="edit(record.id)">重命名</a>
                    </span>

                    <a-divider type="vertical" />
                    <a @click="handlePreview(record)">预览</a>

                    <a-divider type="vertical" />
                    <a @click="download(record.id)">下载</a>

                    <a-divider type="vertical" />
                    <a @click="fileMove(record.id)">移动</a>

                    <a-divider type="vertical" />
                    <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="handleDelete(record.id)">
                      <a>{{ $t('disp.btn.delete') }}</a>
                    </a-popconfirm>
                  </div>
                </a-table>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>

    <!-- 文件夹重命名 -->
    <a-modal
      :title="this.$t('文件夹重命名')"
      :width="500"
      :visible="folderRenameVisible"
      @ok="folderRenameOk"
      @cancel="folderRenameCancel"
    >
      <a-form @keyup.enter.native="folderRenameOk">
        <a-form-item :labelCol="{ span: 0 }" :wrapperCol="{ span: 24 }">
          <a-input :placeholder="$t('输入新的文件夹名')" v-model="newFolderName" :maxLength="100" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 文件夹追加 -->
    <a-modal
      :title="this.$t('文件夹追加')"
      :width="500"
      :visible="folderAddVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="folderForm" @keyup.enter.native="handleOk">
        <a-form-item :labelCol="{ span: 0 }" :wrapperCol="{ span: 24 }">
          <!-- <spn style="text-align: left">Add new folder to current folder</spn> -->
          <a-input
            :placeholder="$t('请填写要添加的文件夹名')"
            v-decorator="['folderName', validatorRules.folderName]"
            :maxLength="100"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 文件夹移动 -->
    <a-modal
      :title="this.$t('文件夹移动')"
      :width="500"
      centered
      :visible="folderMoveVisible"
      @ok="folderMoveOk"
      @cancel="folderMoveCancel"
    >
      <a-form @keyup.enter.native="folderMoveOk">
        <a-form-item :labelCol="{ span: 0 }" :wrapperCol="{ span: 24 }">
          <!-- <a-tree-select
              style="width:100%"
              :dropdownStyle="{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }"
              :treeData="treeData"
              v-model="folderMovePath"
              :placeholder="$t('文件夹移动目录选择')"
            ></a-tree-select> -->
          <p style="font-size: 15px; color: #000000; margin: -12px 0 0; border-radius: 4px; letter-spacing: 4px">
            请选择目标文件夹:
          </p>
          <a-tree
            v-show="treeData.length > 0"
            :treeData="treeData"
            default-expand-all
            :autoExpandParent="autoExpandParentMove"
            :showLine="false"
            :defaultExpandAll="true"
            :selectedKeys="selectedKeysMove"
            :expandedKeys="iExpandedKeysMove"
            @select="onSelectMove"
            @expand="onExpandMove"
          >
            <div slot="hasSlot" slot-scope="{ title, key }">
              <a-icon v-if="key == selectedKeysMove" theme="filled" type="folder-open" class="i-folder"></a-icon>
              <a-icon v-else theme="filled" type="folder" class="i-folder"></a-icon>
              <div
                style="
                  display: inline-block;
                  max-width: calc(100% - 60px);
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  line-height: 18px;
                  position: relative;
                  top: 4px;
                "
                v-html="title"
              ></div>
            </div>
          </a-tree>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-spin>
</template>
<script>
import { httpAction, deleteAction, getAction, postAction, uploadFileAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'

export default {
  name: 'FileManage',
  mixins: [tableMixin],
  inject: ['preview'],
  components: {},
  data() {
    return {
      imgSavePath: '',
      searchText: '',
      currSelected: {},
      treeData: [],
      selectedKeys: [],
      currSelectedKey: '',
      iExpandedKeys: [],
      useClassicIcons: true,
      autoExpandParent: true,
      folderSelected: '',
      loading: false,
      visible: false,
      imgSavePath: '',
      folderRenameVisible: false,
      folderAddVisible: false,
      folderName: '',
      folderMoveVisible: false,
      folderMovePath: '',
      fileMoveVisible: false,
      fileMoveIdInfo: '',
      iExpandedKeysMove: [],
      selectedKeysMove: [],
      autoExpandParentMove: true,
      fileList: [],
      searchName: '',
      attachedFile: '',
      renameText: '',
      editingKey: '',
      cacheData: [],
      messageList1: '',
      reportOkCnt: 0,
      reportSelectedCnt: 0,
      folderForm: this.$form.createForm(this),
      newFolderName: '',
      computeStyle: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 7 },
        lg: { span: 6 },
        xl: { span: 5 },
        xxl: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns: [
        {
          title: '　#',
          dataIndex: 'fileType',
          scopedSlots: { customRender: 'icon' },
          align: 'left',
          width: 60,
        },
        {
          title: '文件名',
          dataIndex: 'fileName',
          //width: '40%',
          scopedSlots: { customRender: 'fileName' },
        },
        {
          title: '文件大小',
          dataIndex: 'fileSize',
          // align: 'center',
          // width: 100,
          scopedSlots: { customRender: 'fileSize' },
        },
        {
          title: '创建时间',
          dataIndex: 'fileCreatedTime',
          // align: 'center',
          scopedSlots: { customRender: 'fileCreatedTime' },
          // width: 180
        },
        {
          title: '更新时间',
          dataIndex: 'fileModifiedTime',
          scopedSlots: { customRender: 'fileModifiedTime' },
          // align: 'center',
          // width: 180
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      validatorRules: {
        folderName: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }],
        },
      },
      url: {
        queryTreeList: '/blaze-sys/k00/k0016/FileManage/queryTreeList',
        queryTreeNodeList: '/blaze-sys/k00/k0016/FileManage/queryTreeNodeList',
        add: '/blaze-sys/k00/k0016/FileManage/folderAdd',
        uploadFile: '/blaze-sys/k00/k0016/FileManage/uploadFile',
        delete: '/blaze-sys/k00/k0016/FileManage/delete',
        deleteBatch: '/blaze-sys/k00/k0016/FileManage/deleteBatch',
        fileRename: '/blaze-sys/k00/k0016/FileManage/fileRename',
        folderRename: '/blaze-sys/k00/k0016/FileManage/folderRename',
        folderDelete: '/blaze-sys/k00/k0016/FileManage/folderDelete',
        folderMove: '/blaze-sys/k00/k0016/FileManage/folderMove',
        fileMove: '/blaze-sys/k00/k0016/FileManage/fileMove',
        download: '/blaze-sys/k00/k0016/FileManage/download',
      },
    }
  },
  computed: {
    isLeaf: function () {
      return this.rightClickSelectedIsLeaf
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  //watch: {
  //  ipagination: {
  //    handler(newVal, oldVal) {
  //      this.$nextTick(() => {
  //        if (document.querySelector('.file-manage-table')) {
  //          document.querySelector('.file-manage-tree').style.height =
  //            document.querySelector('.file-manage-table').clientHeight + 99 + 'px'
  //        }
  //      })
  //    },
  //    immediate: true,
  //    deep: true,
  //  },
  //},
  mounted() {
    this.loadTree()
  },
  methods: {
    loadTree() {
      var that = this
      that.treeData = []

      getAction(that.url.queryTreeList, {}).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.treeData.push(temp)
            that.setThisExpandedKeys(temp)
          }
        }
      })
    },
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        var isAllYearMonth = true
        for (let index = 0; index < node.children.length && isAllYearMonth; index++) {
          const nodeChildren = node.children[index]

          if (moment(nodeChildren.title).format('YYYY-MM') == 'Invalid date') {
            isAllYearMonth = false
          }
        }

        if (isAllYearMonth) return

        this.iExpandedKeys.push(node.key)
        this.iExpandedKeysMove.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },
    onSelect(selectedKeys, info) {
      console.log('selected', selectedKeys, info)

      let record = info.node.dataRef
      if (this.selectedKeys == record.key) {
        this.onClearSelectedTree()
      } else {
        //データをロードする。パラメータは1の場合、第一ページをロードする
        this.ipagination.current = 1
        this.currSelected = Object.assign({}, record)
        this.selectedKeys = [record.key]
        this.currSelectedKey = record.key
        this.queryTreeNodeInfo()
      }
    },
    queryTreeNodeInfo() {
      // 文件夹信息取得
      getAction(this.url.queryTreeNodeList, {
        path: this.currSelectedKey,
        namePara: this.searchName,
      })
        .then((res) => {
          if (res.success) {
            this.dataSource = res.result
            this.cacheData = res.result.map((item) => ({ ...item }))

            //this.$nextTick(() => {
            //  if (document.querySelector('.file-manage-table')) {
            //    document.querySelector('.file-manage-tree').style.height =
            //      document.querySelector('.file-manage-table').clientHeight + 99 + 'px'
            //  }
            //})
          }
        })
        .finally(() => {
          this.editingKey = ''
        })
    },
    searchReset() {
      this.searchName = ''
    },
    onClearSelectedTree() {
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      this.dataSource = []
      this.currSelectedKey = ''
      // this.form.resetFields()
    },
    onCheck(checkedKeys, info) {
      console.log('onCheck', checkedKeys, info)
    },
    fileChange(e) {
      // this.folderSelected = document.querySelector('input[id=file]').files[0]
      // this.folderSelected = document.getElementById('file').value

      try {
        const fu = document.getElementById('file')
        if (fu == null) return
        // this.form.imgSavePath = fu.files[0].path
        console.log(fu.files[0].path)
      } catch (error) {
        console.debug('choice file err:', error)
      }

      // this.folderSelected = document.getElementById('file').value
      // this.loadTree()
    },
    filePathSelect() {
      var file = document.getElementById('file')
      file.click()
    },
    onExpand(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    folderAdd() {
      if (this.selectedKeys != null && this.selectedKeys != '') {
        this.folderAddVisible = true
      } else {
        this.$message.error(this.$t('请选择左侧文件夹目录'))
        return
      }
    },
    uploadFileSet() {
      var file = document.getElementById('upFile')
      file.click()
    },
    upfileSelected(e) {
      let that = this
      var formData = new window.FormData()

      //上传文件取得
      var files = document.querySelector('input[id=upFile]').files
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
      }
      formData.append('path', that.selectedKeys)

      //時間フォーマット
      uploadFileAction(that.url.uploadFile, formData)
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t(res.message))
            // that.loadTree()
            that.queryTreeNodeInfo()
          }
        })
        .finally(() => {
          that.loading = false
          that.folderAddVisible = false
          var obj = document.getElementById('upFile')
          obj.value = ''
        })
    },
    getFileSize(record) {
      var size = record.fileSize
      const kb = size / 1024
      if (kb < 1024) {
        return '<span class="span-main">' + Math.round(kb * 100) / 100 + '</span><span class="span-sub"> KB</span>'
      }
      const mb = kb / 1024
      if (mb < 1024) {
        return '<span class="span-main">' + Math.round(mb * 100) / 100 + '</span><span class="span-sub"> MB</span>'
      }
      return (
        '<span class="span-main">' + Math.round((mb / 1024) * 100) / 100 + '</span><span class="span-sub"> GB</span>'
      )
    },
    getIcon(record) {
      if (record.fileFlag == '1') {
        return '/file-types/folder.png'
      }

      var repository = {
        suffix: record.fileType.toLowerCase(),
      }

      return getFileTypeIcons(repository)

      //var fileType = record.fileType.toLowerCase()

      //if (this.useClassicIcons) {
      //  switch (fileType) {
      //    case 'avi':
      //      return '/icons/mp4.png'
      //      break

      //    case 'css':
      //      return '/icons/css.png'
      //      break

      //    case 'doc':
      //    case 'docx':
      //      return '/icons/doc.png'
      //      break

      //    case 'exe':
      //      return '/icons/exe.png'
      //      break

      //    case 'htm':
      //    case 'html':
      //      return '/icons/html.png'
      //      break

      //    case 'iso':
      //      return '/icons/iso.png'
      //      break

      //    case 'jpeg':
      //    case 'jpg':
      //      return '/icons/png.png'
      //      break

      //    case 'js':
      //      return '/icons/js.png'
      //      break

      //    case 'json':
      //      return '/icons/json.png'
      //      break

      //    case 'mp3':
      //      return '/icons/mp3.png'
      //      break

      //    case 'mp4':
      //      return '/icons/mp4.png'
      //      break

      //    case 'pdf':
      //      return '/icons/pdf.png'
      //      break

      //    case 'png':
      //      return '/icons/png.png'
      //      break

      //    case 'pptx':
      //    case 'ppt':
      //      return '/icons/ppt.png'
      //      break

      //    case 'svg':
      //      return '/icons/html.png'
      //      break

      //    case 'xls':
      //    case 'xlsx':
      //      return '/icons/xls.png'
      //      break

      //    case 'txt':
      //    case 'sql':
      //    case 'xml':
      //      return '/icons/txt.png'
      //      break

      //    case 'zip':
      //      return '/icons/zip.png'
      //      break

      //    default:
      //      return '/icons/file.png'
      //      break
      //  }
      //} else {
      //  switch (fileType) {
      //    case 'avi':
      //      return '/file-types/avi.png'
      //      break

      //    case 'css':
      //      return '/file-types/css.png'
      //      break

      //    case 'doc':
      //    case 'docx':
      //      return '/file-types/doc.png'
      //      break

      //    case 'exe':
      //      return '/file-types/exe.png'
      //      break

      //    case 'htm':
      //    case 'html':
      //      return '/file-types/html.png'
      //      break

      //    case 'iso':
      //      return '/file-types/iso.png'
      //      break

      //    case 'jpeg':
      //    case 'jpg':
      //      return '/file-types/jpg.png'
      //      break

      //    case 'js':
      //      return '/file-types/js.png'
      //      break

      //    case 'json':
      //      return '/file-types/json.png'
      //      break

      //    case 'mp3':
      //      return '/file-types/mp3.png'
      //      break

      //    case 'mp4':
      //      return '/file-types/mp4.png'
      //      break

      //    case 'pdf':
      //      return '/file-types/pdf.png'
      //      break

      //    case 'png':
      //      return '/file-types/png.png'
      //      break

      //    case 'pptx':
      //    case 'ppt':
      //      return '/file-types/ppt.png'
      //      break

      //    case 'svg':
      //      return '/file-types/svg.png'
      //      break

      //    case 'txt':
      //      return '/file-types/txt.png'
      //      break

      //    case 'xls':
      //    case 'xlsx':
      //      return '/file-types/xls.png'
      //      break

      //    case 'xml':
      //      return '/file-types/xml.png'
      //      break

      //    case 'zip':
      //      return '/file-types/zip.png'
      //      break

      //    default:
      //      return '/file-types/file.png'
      //      break
      //  }
      //}
    },
    folderRenameCancel() {
      this.folderRenameVisible = false
    },
    /**
     * 文件夹重命名
     */
    folderRename() {
      if (this.selectedKeys != null && this.selectedKeys != '') {
        this.folderRenameVisible = true
        var fileInfo = this.selectedKeys[0].split('\\')
        this.newFolderName = fileInfo[fileInfo.length - 1]
      } else {
        this.$message.error(this.$t('请选择左侧文件夹目录'))
        return
      }
    },
    /**
     * 文件夹删除
     */
    folderDelete: function () {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      } else {
        var that = this
        this.$confirm({
          title: this.$t('disp.warn'),
          content: this.$t('msg.confirm.deleteBatch'),
          onOk: function () {
            if (that.loading) {
              return
            } else {
              that.loading = true
            }

            let formdata = {}
            formdata.folderPath = that.selectedKeys[0]

            httpAction(that.url.folderDelete, formdata, 'post')
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  // that.loadTree()
                  that.loadTree()
                  that.queryTreeNodeInfo()
                  that.onClearSelectedTree()
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    folderRenameOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      if (this.newFolderName == '') {
        this.loading = false
        this.folderRenameVisible = false
        return
      }

      const that = this
      let formdata = {}
      formdata.oldFolderPath = that.selectedKeys[0]
      formdata.newFolderName = that.newFolderName

      //時間フォーマット
      httpAction(that.url.folderRename, formdata, 'post')
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t(res.message))
            that.loadTree()
            that.queryTreeNodeInfo()
            that.newFolderName = ''
            // that.onClearSelectedTree()
          }
        })
        .finally(() => {
          that.loading = false
          that.folderRenameVisible = false
        })
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      that.folderForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          var formData = that.folderForm.getFieldsValue()
          formData.path = that.selectedKeys[0]

          //時間フォーマット
          console.log(formData)
          httpAction(this.url.add, formData, 'post')
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.loadTree()
                that.queryTreeNodeInfo()
                // that.onClearSelectedTree()
              }
            })
            .finally(() => {
              that.loading = false
              that.folderAddVisible = false
            })
        } else {
          that.loading = false
        }
      })
    },
    handleCancel() {
      this.folderAddVisible = false
    },
    handleDelete(id) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }
      var that = this
      deleteAction(that.url.delete, {
        id: id,
      }).then((res) => {
        if (res.success) {
          that.$message.success(that.$t(res.message))
          // that.loadTree()
          that.queryTreeNodeInfo()
          that.onClearSelected()
          that.editingKey = ''
        }
      })
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error(this.$t('disp.setUrlDeleteBatch'))
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: this.$t('disp.warn'),
          content: this.$t('msg.confirm.deleteBatch'),
          onOk: function () {
            if (that.loading) {
              return
            } else {
              that.loading = true
            }

            deleteAction(that.url.deleteBatch, {
              ids: ids,
            })
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  // that.loadTree()
                  that.queryTreeNodeInfo()
                  that.onClearSelected()
                  that.editingKey = ''
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title
    },
    keywordsColorful(str, key) {
      var reg = new RegExp('(' + key + ')', 'g')
      var newStr = str.replace(reg, "<font style='background:#ff0;'>$1</font>")
      return newStr
    },
    handleChange(value, key, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.id)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    edit(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.id)[0]
      this.editingKey = key
      if (target) {
        target.editable = true

        if (target['fileFlag'] != '1') {
          target['fileName'] = target['fileName'].substr(0, target['fileName'].lastIndexOf('.'))
        }
        this.dataSource = newData
      }
    },
    save(record) {
      let that = this

      //进行重命名处理
      let formdata = {}
      formdata.filePath = record.filePath
      formdata.fileName = record.fileName
      formdata.fileType = record.fileType
      formdata.folderPath = that.selectedKeys[0]
      postAction(that.url.fileRename, formdata)
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t(res.message))
            that.queryTreeNodeInfo()
            that.editingKey = ''
          }
        })
        .finally(() => {
          that.loading = false
          that.folderAddVisible = false
        })

      // const newData = [...this.dataSource];
      // const newCacheData = [...this.cacheData];
      // const target = newData.filter(item => key === item.id)[0];
      // const targetCache = newCacheData.filter(item => key === item.id)[0];
      // if (target && targetCache) {
      //   delete target.editable;
      //   this.dataSource = newData;
      //   Object.assign(targetCache, target);
      //   this.cacheData = newCacheData;
      // }
      // this.editingKey = '';
    },
    cancel(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.id)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.id)[0])
        delete target.editable
        this.dataSource = newData
      }
    },
    handlePreview(record) {
      this.preview(record.filePath)
    },
    download(filePath) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      let text = filePath + '::1'
      this.uploadFile(text)
      this.loading = false
    },
    batchDownload() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      // 总选择文件数设定
      this.reportSelectedCnt = this.selectedRowKeys.length

      for (let r of this.selectedRowKeys) {
        let filePathPara = r.split(';')[0]

        // ダウンロード
        let text = filePathPara + '::1'
        this.uploadFile(text)
        this.reportOkCnt++
      }
      this.doBatchAction()
    },
    doBatchAction() {
      var interval = setInterval(() => {
        // 判断出力終了かどうか
        if (this.reportSelectedCnt > 0 && this.reportOkCnt == this.reportSelectedCnt) {
          clearInterval(interval)

          this.reportOkCnt = 0
          this.reportSelectedCnt = 0
          // ローディング終了
          this.loading = false
        }
      }, 100)
    },
    // 文件夹移动设定
    folderMove() {
      if (this.selectedKeys != null && this.selectedKeys != '') {
        this.folderMoveVisible = true
      } else {
        this.$message.error(this.$t('请选择左侧文件夹目录'))
        return
      }
    },
    // 文件移动处理
    folderMoveOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this

      var oldParentPath = ''
      if (that.fileMoveVisible) {
        oldParentPath = that.fileMoveIdInfo
      } else {
        oldParentPath = that.selectedKeys[0].substr(0, that.selectedKeys[0].lastIndexOf('\\'))
      }

      // var oldParentPath = that.selectedKeys[0].substr(0, that.selectedKeys[0].lastIndexOf('\\'))
      var newParentPath = that.folderMovePath
      if (that.folderMovePath == '' || that.selectedKeys[0] == that.folderMovePath || oldParentPath == newParentPath) {
        // 当选择的移动目录与原目录一样，或者为原目录的父目录时 不进行移动文件夹处理
        this.loading = false
        this.folderMoveVisible = false
        return
      }

      var fileMovePara = ''
      let formdata = {}
      if (that.fileMoveVisible) {
        formdata.oldFolderPath = that.fileMoveIdInfo
        fileMovePara = that.url.fileMove
      } else {
        formdata.oldFolderPath = that.selectedKeys[0]
        fileMovePara = that.url.folderMove
      }
      formdata.newFolderPath = that.folderMovePath

      //時間フォーマット
      httpAction(fileMovePara, formdata, 'post')
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t('文件移动成功'))
            that.loadTree()
            that.queryTreeNodeInfo()
            that.folderMovePath = ''
            that.onClearSelected()
            // that.onClearSelectedTree()
          }
        })
        .finally(() => {
          that.loading = false
          that.folderMoveVisible = false
          that.fileMoveVisible = false
          that.fileMoveIdInfo = ''

          that.selectedKeysMove = []
          that.currSelectedKeyMove = ''
        })
    },
    // 文件移动取消
    folderMoveCancel() {
      this.folderMoveVisible = false
      this.fileMoveVisible = false

      this.selectedKeysMove = []
      this.currSelectedKeyMove = ''
    },
    // 要移动的树节点选择
    onSelectMove(selectedKeys, info) {
      console.log('selected', selectedKeys, info)

      let record = info.node.dataRef
      if (this.selectedKeysMove == record.key) {
        this.currSelectedMove = {}
        this.selectedKeysMove = []
        this.currSelectedKeyMove = ''
      } else {
        this.currSelectedMove = Object.assign({}, record)
        this.selectedKeysMove = [record.key]
        this.currSelectedKeyMove = record.key
        this.folderMovePath = record.key
      }
    },
    // 树节点展开
    onExpandMove(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeysMove = expandedKeys
      this.autoExpandParentMove = false
    },
    // 单个文件移动处理
    fileMove(fileId) {
      if (fileId != null && fileId != '') {
        this.folderMoveVisible = true
        this.fileMoveVisible = true
        this.fileMoveIdInfo = fileId
      }
    },
    // 批量移动处理
    batchMove() {
      // 总选择文件数设定
      this.reportSelectedCnt = this.selectedRowKeys.length

      var fileIdPara = ''
      for (let r of this.selectedRowKeys) {
        let filePathPara = r.split(';')[0]
        fileIdPara += filePathPara + ','
      }

      this.folderMoveVisible = true
      this.fileMoveVisible = true
      this.fileMoveIdInfo = fileIdPara.substr(0, fileIdPara.length - 1)
    },
  },
}
</script>
<style lang="less" scoped>
.i-folder {
  margin-right: 6px;
  color: #e7c146 !important;
  font-size: 17px;
  position: relative;
  top: 1px;
  left: -4px;
}

// /deep/ ul[role='tree'] .ant-tree-node-content-wrapper {
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }

/deep/ .ant-tree li.ant-tree-treenode-switcher-close:before,
/deep/ .ant-tree li.ant-tree-treenode-switcher-open:before {
  width: 28px;
}

/deep/ .anticon-caret-down.ant-tree-switcher-icon {
  border-left: 9px solid white;
  margin-left: -9px;
  background: white;
  position: relative;
  top: -1px;
}

.div-fileType {
  //height: 42px;
  //display: flex;
  //align-items: center;
  //justify-content: center;

  i {
    font-size: 22px;
    position: relative;
    top: 3px;
  }

  img {
    max-height: 100%;
    filter: saturate(1.2);
    width: 30px;
    height: 30px;
  }
}

/deep/
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td {
  padding: 8px 8px;
}

.table-page-search-wrapper {
  margin: 5px 0 0px;
  display: flow-root;
}

/deep/ .ant-table-tbody > tr:last-child {
  border-bottom: 1px solid #e8e8e8;
}

/deep/ span.span-main {
  color: rgba(0, 0, 0, 85%);
}

/deep/ span.span-sub {
  font-size: 12px;
  color: var(--color-grey);
  display: block;
  position: relative;
  top: 1px;
}

.table-operator .ant-btn {
  padding: 0 10px;
}

.i-op-wrapper {
  font-size: 18px;
  display: inline-block;
  width: 100px;
  justify-content: space-evenly;
  position: absolute;
  margin-left: 15px;
  transition: all 0.3s;
  opacity: 0;
  transform: translateX(15px);
  margin-top: 1px;

  i {
    transition: all 0.3s;
    margin-right: 2px;
  }

  i:hover {
    opacity: 1 !important;
  }

  &:hover i {
    opacity: 0.5;
  }
}

.i-op-wrapper.show {
  opacity: 1;
  transform: translateX(0px);
}

/deep/ ul[role='tree'] .ant-tree-node-content-wrapper {
  width: 100%;
  max-width: unset;
}

.div-text {
  max-width: calc(100% - 60px);
}

.ant-tree-node-selected .div-text {
  max-width: calc(100% - 140px);
}

/deep/ .file-manage-tree > li {
  padding-top: 0px;
}

/deep/ .ant-tree-switcher_close .anticon-caret-down.ant-tree-switcher-icon {
  top: 0px;
}
</style>

<style lang="less">
.div-file-manage-tree-wrapper {
  height: calc(100vh - 235px);
  overflow-x: hidden;
  overflow-y: scroll;
  width: calc(100% + 27px);
  padding-right: 22px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }
}

.ant-layout-has-sider .div-file-manage-tree-wrapper {
  height: calc(100vh - 196px);
}
</style>
